import React from "react";
import {Badge, BadgeProps} from "@mui/joy";


interface CustomBadgeProps extends BadgeProps {
    invisible?: boolean;
    sx?: any;
    classname?: string;
}


export const ActiveUserBadge: React.FC<CustomBadgeProps> = (
    {
        anchorOrigin = {
            vertical: 'bottom',
            horizontal: 'right'
        },
        badgeInset = '14%',
        size = 'sm',
        sx,
        invisible = false,
        classname,
        ...props
    }) => {
    const defaultSx = {
        '& .MuiBadge-badge': {
            backgroundColor: 'var(--lgc-palette-success-80)',
        },
        '--Badge-ringSize': '2px',
        '--Badge-minHeight': '6px',
        '--Badge-paddingX': '0',
    };

    const combinedSx = {...defaultSx, ...sx};

    return (
        <Badge
            className={classname}
            anchorOrigin={anchorOrigin}
            badgeInset={badgeInset}
            size={size}
            sx={combinedSx}
            invisible={invisible}
            {...props}
        />
    );
};
